import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "backdrop", "panel", "closeButton"]
  static values = { open: Boolean }
  
  connect() {
    this.openValue = false
    this.hide()
  }
  
  open() {
    if (this.openValue) return
    
    this.openValue = true
    this.menuTarget.classList.remove("hidden")
    
    // Force reflow before adding transition classes
    this.menuTarget.offsetHeight
    
    // Backdrop animation: opacity-0 to opacity-100
    this.backdropTarget.classList.add("transition-opacity", "ease-linear", "duration-300")
    this.backdropTarget.classList.remove("opacity-0")
    this.backdropTarget.classList.add("opacity-100")
    
    // Panel animation: -translate-x-full to translate-x-0
    this.panelTarget.classList.add("transition", "ease-in-out", "duration-300", "transform")
    this.panelTarget.classList.remove("-translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    
    // Close button animation: opacity-0 to opacity-100
    this.closeButtonTarget.classList.add("ease-in-out", "duration-300")
    this.closeButtonTarget.classList.remove("opacity-0")
    this.closeButtonTarget.classList.add("opacity-100")
    
    // Prevent body scroll
    document.body.style.overflow = "hidden"
  }
  
  close() {
    if (!this.openValue) return
    
    this.openValue = false
    
    // Backdrop animation: opacity-100 to opacity-0
    this.backdropTarget.classList.add("transition-opacity", "ease-linear", "duration-300")
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    
    // Panel animation: translate-x-0 to -translate-x-full
    this.panelTarget.classList.add("transition", "ease-in-out", "duration-300", "transform")
    this.panelTarget.classList.remove("translate-x-0")
    this.panelTarget.classList.add("-translate-x-full")
    
    // Close button animation: opacity-100 to opacity-0
    this.closeButtonTarget.classList.add("ease-in-out", "duration-300")
    this.closeButtonTarget.classList.remove("opacity-100")
    this.closeButtonTarget.classList.add("opacity-0")
    
    // Hide menu after animation completes
    setTimeout(() => {
      this.hide()
    }, 300)
    
    // Restore body scroll
    document.body.style.overflow = ""
  }
  
  hide() {
    this.menuTarget.classList.add("hidden")
    
    // Reset backdrop classes
    this.backdropTarget.classList.remove("transition-opacity", "ease-linear", "duration-300", "opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    
    // Reset panel classes  
    this.panelTarget.classList.remove("transition", "ease-in-out", "duration-300", "transform", "translate-x-0")
    this.panelTarget.classList.add("-translate-x-full")
    
    // Reset close button classes
    this.closeButtonTarget.classList.remove("ease-in-out", "duration-300", "opacity-100")
    this.closeButtonTarget.classList.add("opacity-0")
  }
  
  toggle() {
    this.openValue ? this.close() : this.open()
  }
  
  backdropClick(event) {
    // Close menu when clicking on backdrop
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }
  
  // Handle escape key
  keydown(event) {
    if (event.key === "Escape" && this.openValue) {
      this.close()
    }
  }
  
  disconnect() {
    // Clean up body scroll lock if controller is removed while menu is open
    document.body.style.overflow = ""
  }
}